
import { TextStyledProperty } from "@/utils/documents/text-styled-property";
import Vue from "vue";
export default Vue.extend({
	props: {
		title: Object as () => TextStyledProperty,
		text: Object as () => TextStyledProperty,
		signature: Object as () => TextStyledProperty,
		date: Object as () => TextStyledProperty
	},
	i18nEx: {
		componentPrefix: "components.reminder-layout-editor"
	}
});
